import clsx from "clsx";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Placement } from "react-bootstrap/esm/types";
import { copyToClipboard } from "../utils";
import Icon, { Sizes } from "./Icon";

type CopyToClipboardProps = {
  icon?: string;
  size?: Sizes;
  tooltipText?: string;
  placement?: Placement;
  value?: string;
  subjectText?: string;
  className?: string;
  containerClassName?: string;
  setContainerLineHeight?: boolean;
};

const CopyToClipboard = ({
  icon = "copy-clipboard-alt",
  size = 14,
  tooltipText = "Copy to Clipboard",
  placement = "bottom",
  value,
  subjectText,
  className,
  containerClassName,
  setContainerLineHeight = true
}: CopyToClipboardProps) => (
  <OverlayTrigger
    overlay={<Tooltip>{tooltipText}</Tooltip>}
    placement={placement}
  >
    <span
      role="button"
      className={clsx(
        setContainerLineHeight && "line-height-small",
        containerClassName
      )}
    >
      <Icon
        size={size}
        className={clsx("copy-to-clipboard", className)}
        name={icon}
        onClick={event => {
          event.stopPropagation();
          copyToClipboard(value, subjectText);
        }}
        data-testid="copy_to_clipboard"
      />
    </span>
  </OverlayTrigger>
);

export default CopyToClipboard;
